import { ScrollItemVO } from "./ScrollItemVO";
import { ScrollItemEvent } from "./ScrollItemEvent";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class ScrollItem extends MovieClip {
    protected _isActive: boolean = false;
    protected _scrollItemVO: ScrollItemVO;
    protected _genericVO: Object;
    protected _disp: MovieClip;

    constructor(disp: MovieClip) {
        // see http://createjs.com/docs/easeljs/files/easeljs_display_MovieClip.js.html#l41
        super();
        this._disp = disp;
    }

    protected onMouseClick(event: MouseEvent): void {
        this.dispatchEvent(new ScrollItemEvent(ScrollItemEvent.CLICK, this, event.target));
    }

    protected onRollOver(event: MouseEvent): void {
        this.dispatchEvent(new ScrollItemEvent(ScrollItemEvent.ROLL_OVER, this, event.target));
    }

    protected onRollOut(event: MouseEvent): void {
        this.dispatchEvent(new ScrollItemEvent(ScrollItemEvent.ROLL_OUT, this, event.target));
    }

    public /*final*/ fillWithContent(scrollItemVO: ScrollItemVO): void {
        this._scrollItemVO = scrollItemVO;
        this.customFillItem();
    }

    protected customFillItem(): void {
        // for override
    }

    public show(): void {
        this._disp.visible = true;
        this._disp.addEventListener("click", this.bindFunction(this.onMouseClick));
        this._disp.addEventListener("rollover", this.bindFunction(this.onRollOver));
        this._disp.addEventListener("rollout", this.bindFunction(this.onRollOut));
    }

    public hide(): void {
        this._disp.visible = false;
        this._disp.removeEventListener("click", this.bindFunction(this.onMouseClick));
        this._disp.removeEventListener("rollout", this.bindFunction(this.onRollOut));
        this._disp.removeEventListener("rollover", this.bindFunction(this.onRollOver));
    }

    public reset(): void {

    }

    public get isActive(): boolean {
        return this._isActive;
    }

    protected onActiveStateChange(): void {
        // for override
    }

    public set isActive(value: boolean) {
        this._isActive = value;
        this.onActiveStateChange();
    }

    public get disp(): MovieClip {
        return this._disp;
    }

    public remove(): void {
        this.hide();
    }

    public get scrollItemVO(): ScrollItemVO {
        return this._scrollItemVO;
    }

    public set scrollItemVO(value: ScrollItemVO) {
        this._scrollItemVO = value;
    }
}
